import { MockFactory } from '@tino-frontend/mocks'
import {
  CheckUnicoResultResponse,
  CheckUnicoResultResponseResult,
} from '@types'

export const CheckUnicoResultResponseLivenessReprovedMock =
  new MockFactory<CheckUnicoResultResponse>({
    result: CheckUnicoResultResponseResult.LIVENESS_REPROVED,
  })
